/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {AnimatedTemplateModel} from "@/models/animatedTemplateModel";

export const BASIC_THEME_ID = 1;
export const COLLAGE_THEME_ID = 2;

export class AnimatedThemeModel extends JsonModel<AnimatedThemeModel.IJson> {}

export namespace AnimatedThemeModel {
  export interface IJson {
    id: number;
    name: string;
    templates: AnimatedTemplateModel.IJson[];
  }
}
/* v8 ignore stop */
